export enum GenderTypeEnum {
   Male = 0,
   Female = 1
}
export interface CreatePersonDto {
    name?:string;
    email?:string;
    isEmailValidPerson: boolean;
    phoneNumber?:string ;
    uniqueCode?:string;
    actualAddress?:string;
    validToDate: Date;
    issuedDate: Date;
    issuedBy?:string;
    gender?:number;
    documentNumber?:string;
    documentSeries?:string;
    documentType?:string;
    citizenship?:string;
    addressOfBirth?:string;
    dateOfBirth: Date;
    tin?:string;
    photo?:string;
    lastName?:string;
   firstName?:string; 
}